import { render, staticRenderFns } from "./PricingTablePriceBlock.vue?vue&type=template&id=4a0120dd&"
import script from "./PricingTablePriceBlock.vue?vue&type=script&lang=js&"
export * from "./PricingTablePriceBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports